import PagerOutlinedIcon from '@juvare/common-web-ui/icons/PagerOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import EmailIcon from '@mui/icons-material/Email';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import FaxIcon from '@mui/icons-material/Fax';
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import PhoneEnabledIcon from '@mui/icons-material/PhoneEnabled';
import PushPinIcon from '@mui/icons-material/PushPin';
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import RemoveModeratorIcon from '@mui/icons-material/RemoveModerator';
import SendTimeExtensionOutlinedIcon from '@mui/icons-material/SendTimeExtensionOutlined';
import SubtitlesOutlinedIcon from '@mui/icons-material/SubtitlesOutlined';
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined';
import TextsmsIcon from '@mui/icons-material/Textsms';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
export const icons = {
    // begin, keep this list sorted alphabetically
    'icon-add': AddOutlinedIcon,
    'icon-check-circle-outline': CheckCircleOutlineIcon,
    'icon-email': EmailIcon,
    'icon-error-outline': ErrorOutlineIcon,
    'icon-fax': FaxIcon,
    'icon-forward-to-inbox-outlined': ForwardToInboxOutlinedIcon,
    'icon-group-add-outlined': GroupAddOutlinedIcon,
    'icon-help-outline': HelpOutlineIcon,
    'icon-inbox-outlined': InboxOutlinedIcon,
    'icon-message-outlined': MessageOutlinedIcon,
    'icon-monitor-heart-outlined': MonitorHeartOutlinedIcon,
    'icon-pager-outlined': PagerOutlinedIcon,
    'icon-person-add-outlined': PersonAddAltOutlinedIcon,
    'icon-phone-enabled': PhoneEnabledIcon,
    'icon-push-pin': PushPinIcon,
    'icon-question-answer-outlined': QuestionAnswerOutlinedIcon,
    'icon-question-mark': QuestionMarkIcon,
    'icon-remove': RemoveCircleOutlineOutlinedIcon,
    'icon-remove-moderator': RemoveModeratorIcon,
    'icon-send-time-extension-outlined': SendTimeExtensionOutlinedIcon,
    'icon-subtitles-outlined': SubtitlesOutlinedIcon,
    'icon-task-outlined': TaskOutlinedIcon,
    'icon-textsms': TextsmsIcon,
    'icon-whats-app': WhatsAppIcon,
    // end, keep this list sorted alphabetically
};
export const pickerIcons = {
    'icon-add': {
        icon: AddOutlinedIcon,
        'aria-label': 'Add',
        tooltip: 'Add',
    },
    'icon-remove': {
        icon: RemoveCircleOutlineOutlinedIcon,
        'aria-label': 'Remove',
        tooltip: 'Remove',
    },
    'icon-check-circle-outline': {
        icon: CheckCircleOutlineIcon,
        'aria-label': 'Check Circle',
        tooltip: 'Check Circle',
    },
    'icon-email': {
        icon: EmailIcon,
        'aria-label': 'Email',
        tooltip: 'Email',
    },
    'icon-error-outline': {
        icon: ErrorOutlineIcon,
        'aria-label': 'Error',
        tooltip: 'Error',
    },
    'icon-fax': {
        icon: FaxIcon,
        'aria-label': 'Fax',
        tooltip: 'Fax',
    },
    'icon-forward-to-inbox-outlined': {
        icon: ForwardToInboxOutlinedIcon,
        'aria-label': 'Forward To Inbox',
        tooltip: 'Forward To Inbox',
    },
    'icon-group-add-outlined': {
        icon: GroupAddOutlinedIcon,
        'aria-label': 'Group Add',
        tooltip: 'Group Add',
    },
    'icon-help-outline': {
        icon: HelpOutlineIcon,
        'aria-label': 'Help',
        tooltip: 'Help',
    },
    'icon-message-outlined': {
        icon: MessageOutlinedIcon,
        'aria-label': 'Message',
        tooltip: 'Message',
    },
    'icon-monitor-heart-outlined': {
        icon: MonitorHeartOutlinedIcon,
        'aria-label': 'Monitor Heart',
        tooltip: 'Monitor Heart',
    },
    'icon-pager-outlined': {
        icon: PagerOutlinedIcon,
        'aria-label': 'Pager',
        tooltip: 'Pager',
    },
};
